// extracted by mini-css-extract-plugin
export var Container = "FeedPage-module--Container--15wCg";
export var Link = "FeedPage-module--Link--3QnFP";
export var ImageContainer = "FeedPage-module--ImageContainer--1G9aI";
export var TextContainer = "FeedPage-module--TextContainer--2TUTN";
export var Links = "FeedPage-module--Links--18nhy";